import React from "react"

const SyncTab = () => {
  return <div>TODO: Sync tab</div>
}

export default SyncTab
